import { Hero } from '../components/Hero';
// import TopMovers from '../components/TopMovers';

export function Default() {
  return (
    <>
      <Hero />

      {/* <TopMovers /> */}
      {/* Mindset section removed for now */}
    </>
  );
}
